import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './radio-select.scss';

export default class RadioSelect extends Component {
	static propTypes = {
		id: PropTypes.string.isRequired,
		renderLabel: PropTypes.func.isRequired,
		onRadioSelect: PropTypes.func.isRequired,
		isChecked: PropTypes.bool.isRequired,
	};

	handleRadioSelect = () => {
		this.props.onRadioSelect(this.props.id);
	};

	render() {
		const { renderLabel, isChecked } = this.props;

		return (
			<label className="radio-label">
				<input
					type="radio"
					checked={isChecked}
					onChange={this.handleRadioSelect}
				/>
				{renderLabel()}
			</label>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ConfirmMultipleEntryDropshipModal/radio-select.js